import styled from "@emotion/styled"

const RailControlPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .tabs-shell {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    overflow: hidden;
  }

  .tabs-head {
    border-bottom: 1px solid var(--cms-border);
    background: var(--cms-table-head-bg);
    padding: 0 10px;
  }

  .tabs-head .MuiTab-root {
    text-transform: none;
    font-weight: 700;
    min-height: 48px;
  }

  .tab-panel {
    padding: 14px;
  }
`

export { RailControlPanelWrapper }
